import ServerCard from "../../../compenents/server-card";
import React from "react";
import {Col, Row} from "antd";
import styles from "./advantage/index.module.scss";

const ServerCardList = ({data = []}) => {
    return (
        <>
            <div className={styles['section-title']}>
                <div className={styles.chs}>服务项目</div>
            </div>

            <Row gutter={[16, 16]}>
                {
                    data.map(d => (
                        <Col span={6} key={d.id}>
                            <ServerCard imgUrl={d.imgUrl} title={d.name} content={d.content}/>
                        </Col>
                    ))
                }
            </Row>
        </>

    )
}

export default ServerCardList